// ets_tracing: off
export const ArrayIndexOutOfBoundsExceptionTypeId = /*#__PURE__*/Symbol();
export class ArrayIndexOutOfBoundsException {
  constructor(index) {
    this.index = index;
    this._typeId = ArrayIndexOutOfBoundsExceptionTypeId;
  }

}
//# sourceMappingURL=ArrayIndexOutOfBoundsException.mjs.map